import {
    ORDER_REQUEST,
    ORDER_SUCCESS,
    ORDER_FAILED,
    ORDER_DELETE,
    ORDER_ITEM_LIST_REQUEST,
    ORDER_ITEM_LIST_SUCCESS,
    ORDER_ITEM_LIST_FAILED,
    ORDER_ITEM_GET_REQUEST,
    ORDER_ITEM_GET_SUCCESS,
    ORDER_ITEM_GET_FAILED,
    BUYING_INFO_SAVE,
    BUYING_INFO_DELETE
} from "../constants/buyingConstants"

import { baseAxios } from "../jwtInterceptor"

export const order_action = (payment_method, payment_id, reservation_item_id, total_price) => async(dispatch) => {
    try{
        dispatch({type:ORDER_REQUEST})
        baseAxios.defaults.headers.common["Authorization"] = `Bearer ${JSON.parse(localStorage.getItem('accountInfo')).access}`;

        // Create internal payment record
        const payInit = await baseAxios.post('/api/buying/payment', {
            payment_method,
            payment_id,
        })

        // Create order record
        const orderResp = await baseAxios.post('/api/buying/order', {
            payment: payInit.data.id,
            total_price,
            tax: 0.1,
        })

        // Trigger payment intent on server
        const buyResp = await baseAxios.post('/api/buying/', {
            payment_method: 'card',
            payment_id,
            total_price,
            order_id: orderResp.data.id,
        })

        // SCA flow required
        if (buyResp.data && buyResp.data.requires_action) {
            return buyResp.data
        }

        // Create order item after successful charge
        const itemResp = await baseAxios.post('/api/buying/order_item', {
            order_id: orderResp.data.id,
            reservation_item_id,
            quantity: 1,
        })
        dispatch({type: ORDER_SUCCESS, payload: itemResp.data})
        return itemResp.data
    }catch(error){
        dispatch({type:ORDER_FAILED,
            payload: error.response && error.response.data.message ? error.response.data.message : error.message})
        return undefined
    }
}

export const order_info_delete = () => (dispatch) => {
    dispatch({type: ORDER_DELETE, payload: ''})
}

export const order_item_list = () => async(dispatch) => {
    dispatch({
        type: ORDER_ITEM_LIST_REQUEST
    })

    baseAxios.defaults.headers.common["Authorization"] = `Bearer ${JSON.parse(localStorage.getItem('accountInfo')).access}`;
    await baseAxios.get('/api/buying/order_item_list').then(
        (response) => {
            dispatch({type: ORDER_ITEM_LIST_SUCCESS, payload:response['data']})
        }
    ).catch(
        () => {
            const data = {
                'message': '購入した商品がありません'
            }
            dispatch({type: ORDER_ITEM_LIST_FAILED, payload: data})
        }
    )
}

export const order_item_get = (id) => async(dispatch) => {

        dispatch({type: ORDER_ITEM_GET_REQUEST})
        baseAxios.defaults.headers.common["Authorization"] = `Bearer ${JSON.parse(localStorage.getItem('accountInfo')).access}`;
        await baseAxios.get(`/api/buying/order_item/${id}`).then(
            (response) => {
                dispatch({type: ORDER_ITEM_GET_SUCCESS, payload: response['data']})
            }
        ).catch(
            () => {
                dispatch({type: ORDER_ITEM_GET_FAILED, payload: 'このアイテムについての購入履歴情報が取得できませんでした。'})
            }
        )
}

export const buying_info_save = (payment_method, payment_id, total_price, product_name, status) => (dispatch) => {
    const data = {
        "payment_method": payment_method,
        "payment_id": payment_id,
        "total_price": total_price,
        "product_name": product_name,
        "status": status
    }
    dispatch({
        type: BUYING_INFO_SAVE, payload:data
    })
    localStorage.setItem('buying', JSON.stringify(data))
}

export const buying_info_delete = () => (dispatch) => {
    localStorage.removeItem('buying')
    dispatch({
        type:BUYING_INFO_DELETE, payload:''
    })
}
